import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Alert, Glyphicon, PanelGroup, Panel } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import CenterDetailsLink from '../../../common/components/CenterDetailsLink';
import GradeDetailsLink from '../../../common/components/GradeDetailsLink';
import TermThemeLink from '../../../common/components/TermThemeLink';
import TeacherDetailsLink from '../../../common/components/TeacherDetailsLink';
import { withNamespaces, Trans } from 'react-i18next';
import ReduxBlockUi from 'react-block-ui/redux';
import moment from 'moment';
import 'icheck/skins/minimal/grey.css';	// used for styling booking options accordion
import 'react-block-ui/style.css';
import utils from '../../../common/services/utils';
import ui from '../../../common/services/ui';
import { Link } from 'react-router-dom';

class BookingOptions extends Component {
	constructor(props) {
		super(props);

		this.handlePaymentOptionAccordionSelect = this.handlePaymentOptionAccordionSelect.bind(this);
		this.state = {
			selectedPaymentTypeKeys: {}
		};
	}

	componentWillReceiveProps(nextProps) {
		// trigger Confirm after payment type is selected and props are updated
		if (!this.props.bookingOptions.selectedPaymentTypeId && nextProps.bookingOptions.selectedPaymentTypeId) {
			this.props.onConfirm();
		}

		// reset selected payment types in local state when new payment types are loaded
		if (this.props.bookingOptions.childrenPaymentTypes !== nextProps.bookingOptions.childrenPaymentTypes) {
			this.setState({
				selectedPaymentTypeKeys: {}
			});
		}
	}

	handlePaymentOptionSelect(paymentTypeId, isPrepaid, isBonusLesson, childId) {
		this.props.onSelectPaymentType({ paymentTypeId, isPrepaid, isBonusLesson });
		if (childId) {
			this.props.onSelectChild(childId);
		}
	}

	handleJoinWaitingListSelect(childId) {
		if (childId) {
			this.props.onSelectChild(childId);
		}
		this.props.onJoinWaitingList();
	}

	renderChildrenInfo() {
		const { children, bookingOptions: { selectedChildId }, blockChildrenInfo, unblockChildrenInfo } = this.props;
		let displayChildren = children;
		if (selectedChildId) {
			displayChildren = children.filter(c => c.id === selectedChildId);
		}

		return <ReduxBlockUi block={blockChildrenInfo} unblock={unblockChildrenInfo} renderChildren={false}>
			{displayChildren.map(child => {
				const name = child.shortName;
				const classes = child.ageAppropriateGrades.map(g => g && <li key={g.id}>{g.name}</li>);
				return (
					<div key={child.id} style={{ marginBottom: '20px' }} className='suitable-classes'>
						<Trans i18nKey={child.ageAppropriateGrades.length > 0 ? 'FO_Booking_Class_AgeAppropriate' : 'FO_Booking_Class_AgeAppropriate_None'} count={child.ageAppropriateGrades.length}>
							Suitable classes for <b style={{ color: '#1d93d1' }}>{{ name }}</b>:
						</Trans>
						<ul>{classes}</ul>
					</div>
				);
			})}
		</ReduxBlockUi>;
	}


	renderErrorWithLogin(isLocked, errorMessage) {

		const { t, postTrial, isAuthenticated } = this.props;
		const showLogin = !isAuthenticated && (isLocked || postTrial);
		return <div>
			<Alert bsStyle="danger" >
				<div className='suitable-classes' dangerouslySetInnerHTML={{ __html: errorMessage }} />
				{showLogin && <div className='suitable-classes' dangerouslySetInnerHTML={{ __html: t('FO_Booking_Validation_ClassesLockedForChildToLogin') }} />}
			</Alert>
			{showLogin && <Link className='btn-block btn btn-primary' style={{ marginBottom: 5 }} to={{ pathname: '/login', state: { from: '/booking/child' } }}>{t('FO_Login_Login')} <i className='fa fa-arrow-circle-right' /></Link>}
		</div>
	}

	renderChildBookingOptions(child, paymentTypes, errorMessage, joinWaitingList, isLocked, t) {

		let allPaymentTypes = paymentTypes.map(p => { return { paymentType: p, isBonusLesson: false }; });
		// add options for bonus lessons
		paymentTypes.filter(p => p.isBonusLessonAllowed).forEach(p => allPaymentTypes.push({ paymentType: p, isBonusLesson: true }));

		const isMultipleOptions = allPaymentTypes.length > 1;
		const firstPaymentOption = allPaymentTypes[0];
		const accordionId = `paymentTypes_${child ? child.id : 1}`;
		const accordionDefaultActiveKey = firstPaymentOption ? this.getPaymentOptionKey(firstPaymentOption.paymentType, firstPaymentOption.isBonusLesson) : null;

		return <div key={child ? child.id : -1} style={{ marginBottom: '10px' }}>
			{child && <p><Glyphicon glyph='user' /> {child.shortName}</p>}
			{errorMessage && this.renderErrorWithLogin(isLocked, errorMessage)}
			{joinWaitingList &&
				<div>					
					<Button className='btn-block btn btn-primary' onClick={() => this.handleJoinWaitingListSelect(child && child.id)}>
						{t('FO_Booking_JoinWaitingList')} <i className='fa fa-arrow-circle-right' />
					</Button>
				</div>
			}
			{!joinWaitingList && <PanelGroup
				accordion id={accordionId}
				defaultActiveKey={accordionDefaultActiveKey}
				onSelect={activeKey => this.handlePaymentOptionAccordionSelect(accordionId, activeKey)}
			>
				{allPaymentTypes.map(p => this.renderPaymentOption(child, p.paymentType, p.isBonusLesson, accordionId, accordionDefaultActiveKey, isMultipleOptions, t))}
			</PanelGroup>
			}
		</div>;
	}

	getPaymentOptionKey(paymentType, isBonusLesson) {
		return `${paymentType.id}${paymentType.isPrepaid ? '_Prepaid' : ''}${isBonusLesson ? '_Bonus' : ''}`;
	}

	handlePaymentOptionAccordionSelect(accordionId, activeKey) {
		this.setState({
			selectedPaymentTypeKeys: {
				...this.state.selectedPaymentTypeKeys,
				[accordionId]: activeKey
			}
		});
	}

	renderPaymentOption(child, paymentType, isBonusLesson, accordionId, defaultAccordionKey, isMultipleOptions, t) {
		const key = this.getPaymentOptionKey(paymentType, isBonusLesson);
		const selectedKey = this.state.selectedPaymentTypeKeys[accordionId];
		const isSelected = selectedKey ? key === selectedKey : key === defaultAccordionKey;

		return <Panel key={key} eventKey={key} className='booking-option'>
			<Panel.Heading className={isSelected ? 'checked' : ''}>
				<Panel.Title toggle={!isSelected} className={isMultipleOptions ? 'radio' : ''} >
					{isMultipleOptions && <div className={`iradio_minimal-grey radio-icon ${isSelected ? 'checked' : ''}`} />}
					{this.renderPaymentOptionContent(paymentType, isBonusLesson, t)}
				</Panel.Title>
			</Panel.Heading>
			<Panel.Body collapsible>
				<Button className='btn-block btn btn-primary' onClick={() => this.handlePaymentOptionSelect(paymentType.id, paymentType.isPrepaid, isBonusLesson, child && child.id)}>
					{t('FO_Booking_BookingOptions_Select')} <i className='fa fa-arrow-circle-right' />
				</Button>
			</Panel.Body>
		</Panel>;
	}

	renderPaymentOptionContent(paymentType, isBonusLesson, t) {
		const { currentCurrency, franchisorCurrency, enableCurrencyConversion } = this.props;
		const conversionLink = ui.getCurrencyConversionLink(enableCurrencyConversion, currentCurrency, franchisorCurrency, paymentType.totalAmount);

		return <div>
			<div className='payment-type'>
				<span style={{ float: 'left' }}>{t(paymentType.displayNameResource)}{isBonusLesson ? `- ${t('FO_Booking_Form_IsBonusLesson')}` : ''}</span>
				<div className='clearfix' />
			</div>
			<div className='price'>
				<span style={{ float: 'left', fontSize: '14px' }}>{paymentType.hideUnitPrice ? t('FO_Booking_BookingOptionTotal') : `${paymentType.quantity} x ${paymentType.unitPrice}`}</span>
				<span style={{ float: 'right' }}>{paymentType.total}</span>
				<div className='clearfix' />
				{conversionLink &&
					<a href={conversionLink} target='_blank' className='currency-conversion' style={{ float: 'right' }}>{t('FO_Common_ConvertToCurrency', { currency: currentCurrency })}</a>}
				<div className='clearfix' />
			</div>
		</div>;
	}

	renderLessonBookingOptions() {
		const { t, block, unblock, bookingOptions: { errorMessage, selectedChildId, selectedPaymentTypeId, childrenPaymentTypes, warningMessage } } = this.props;

		const selectedChild = selectedChildId && childrenPaymentTypes.find(c => c.child && c.child.id === selectedChildId);
		const visibleChildren = selectedChild ? [selectedChild] : childrenPaymentTypes;

		if (errorMessage) {
			return this.renderErrorWithLogin(false, errorMessage)
		}

		const selectedPaymentType = selectedChild && selectedPaymentTypeId && selectedChild.paymentTypes.find(p => p.id === selectedPaymentTypeId);

		return (
			<ReduxBlockUi block={block} unblock={unblock} renderChildren={false}>
				{warningMessage && <Alert bsStyle="warning" >
					<div className='suitable-classes' dangerouslySetInnerHTML={{ __html: warningMessage }} />
				</Alert>}
				{selectedPaymentType ? <div><p><Glyphicon glyph='user' /> {selectedChild.child.shortName}</p><p>{t(selectedPaymentType.displayNameResource)}</p></div> : visibleChildren.map(x => this.renderChildBookingOptions(x.child, x.paymentTypes, x.errorMessage, x.joinWaitingList, x.isLocked, t))}
			</ReduxBlockUi>
		);
	}

	render() {
		const { selectedLesson, enableUserTimeZone, onCancel, children, selectedTerm, t } = this.props;

		const lessonStart = selectedLesson && (enableUserTimeZone ? utils.convertToUserTime(selectedLesson.start, selectedLesson.center) : moment(selectedLesson.start));
		const lessonEnd = selectedLesson && (enableUserTimeZone ? utils.convertToUserTime(selectedLesson.end, selectedLesson.center) : moment(selectedLesson.end));

		return <div>
			<h3>{t('FO_Booking_BookingOptions_Title')}{selectedLesson && <a className='pull-right' style={{ top: '5px', cursor: 'pointer' }} onClick={onCancel}><FontAwesome name='times' /></a>}</h3>

			{!selectedLesson && <div>
				{children && this.renderChildrenInfo()}
			</div>}

			{selectedLesson && <div>
				<p><GradeDetailsLink grade={selectedLesson.grade} /></p>
				{selectedTerm && selectedTerm.themeDescription && <p><TermThemeLink term={selectedTerm} /></p>}
				{selectedLesson.lessonDescription && <p><Glyphicon glyph='info-sign' /> {selectedLesson.lessonDescription}</p>}
				<p><Glyphicon glyph='calendar' /> {lessonStart.format('ll, dddd')}</p>
				<p><Glyphicon glyph='time' /> {lessonStart.format('LT')} - {lessonEnd.format('LT')}
					{selectedLesson.teacher && selectedLesson.teacher.name ? ` ${t('FO_Booking_Form_WithTeacher')} ` : ''}
					{selectedLesson.teacher && selectedLesson.teacher.name &&
						(selectedLesson.teacher.photoUrl || selectedLesson.teacher.bio ?
							<TeacherDetailsLink teacher={selectedLesson.teacher} /> :
							<b>{selectedLesson.teacher.name}</b>)}</p>
				<p><CenterDetailsLink center={selectedLesson.center} />{selectedLesson.roomNumber ? `, ${selectedLesson.roomNumber}` : ''}</p>

				{this.renderLessonBookingOptions()}
			</div>}
		</div>;
	}
}

BookingOptions.propTypes = {
	bookingOptions: PropTypes.shape({
		warningMessage: PropTypes.string,
		errorMessage: PropTypes.string,
		childrenPaymentTypes: PropTypes.arrayOf(PropTypes.shape({
			child: PropTypes.shape({
				fullName: PropTypes.string
			}),
			paymentTypes: PropTypes.arrayOf(PropTypes.shape({
				id: PropTypes.number,
				isPrepaid: PropTypes.bool,
				displayNameResource: PropTypes.string,
				isFree: PropTypes.bool,
				isBonusLessonAllowed: PropTypes.bool,
				hideUnitPrice: PropTypes.bool
			})),
			errorMessage: PropTypes.string,
			joinWaitingList: PropTypes.bool,
			isLocked: PropTypes.bool

		})),
		programId: PropTypes.number,
		date: PropTypes.string,
		selectedChildId: PropTypes.number,
		selectedPaymentTypeId: PropTypes.number,
		isSelectJoinWaitingList: PropTypes.bool,
		isBonusLesson: PropTypes.bool
	}),
	children: PropTypes.arrayOf(PropTypes.shape({
		shortName: PropTypes.string,
		hasTrialLesson: PropTypes.boolean,
		ageAppropriateGrades: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number, name: PropTypes.string }))
	})),
	selectedLesson: PropTypes.shape({
		programId: PropTypes.number,
		grade: PropTypes.shape({
			name: PropTypes.string,
			description: PropTypes.string
		}),
		center: PropTypes.shape({
			name: PropTypes.string,
			address: PropTypes.string,
			addressDescription: PropTypes.string,
			phoneNumber: PropTypes.string,
			additionalInfo: PropTypes.string,
			latitude: PropTypes.number,
			longitude: PropTypes.number,
			utcOffset: PropTypes.number
		}),
		start: PropTypes.string,
		end: PropTypes.string
	}),
	enableUserTimeZone: PropTypes.bool,
	onSelectPaymentType: PropTypes.func.isRequired,
	onJoinWaitingList: PropTypes.func.isRequired,
	onSelectChild: PropTypes.func,
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withNamespaces()(BookingOptions);